import { TYPE_PRODUCTS } from "../../Constants"
import { BundleItem } from "./BundleItem"

export type BundleDtoAttributes = {
    bundleProducts: BundleItem[]
}

export type BundleDto = {
    id: string
    type: string
    attributes: BundleDtoAttributes
}

export const initialBundleAttributes: BundleDtoAttributes = {
    bundleProducts: []
}

export const initialBundleState: BundleDto ={
    id: "",
    type: "",
    attributes: initialBundleAttributes
}

export default class Bundle {
    private dto: BundleDto

    constructor(dto: BundleDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.type === TYPE_PRODUCTS
            && this.getId() != ""
    }

    getId(): string {
        return this.dto.id
    }

    getDto(): BundleDto {
        return this.dto
    }

    getAttributes(): BundleDtoAttributes {
        return this.dto.attributes
    }

}


// WEBPACK FOOTER //
// ./src/state/product/bundle/models/Bundle.ts